import { createElem, optionRow, bootstrapSwitchChange, addElement, createH3Label } from './util/form_fields.js';

var createOption;
$( document ).on('turbo:load', function () {
    if ($('.add-options').length > 0) {
        if($('.hidden_fields').length > 0){
            $('#options').collapse('show');
        }
        var optionsCount = $('#options').data('options_count');
        $('.published').bootstrapSwitch({onColor: 'success', offColor: 'warning'});
        $('.bootstrap-switch').css('vertical-align', 'bottom');
        bootstrapSwitchChange($('.published'), 'selected', true);
        $('.label-input').on('input', function () {
            var idx = '#select_opt option[id=' + $(this).data('id') + ']';
            $(idx).attr('label', $(this).val());
        });

        $('.value-input').on('input', function () {
            var idx = '#select_opt option[id=' + $(this).data('id') + ']';
            $(idx).attr('value', $(this).val());
        });

        createOption = function createOption() {
            if ($('#h3_options').length <= 0) {
                var h3 = createH3Label('Options', 'h3_options');
                addElement('options', h3);
            }
            if ($('#select_opt').length <= 0) {
                var select = createElem('select', ['form-control']);
                select.id = 'select_opt';
                var label = createElem('label');
                label.id = 'example_label';
                label.innerText = 'Example';
                $('#options_container').append(label);
                $('#options_container').append(select);
            }
            var select = $('#select_opt');
            var option = createElem('option', ['select_options']);
            option.selected = false;
            option.id = optionsCount;

            var wrapper = optionRow(option.id);

            var row = createElem('div', ['row']);

            var checkedCol = createElem('div', ['col-sm-2']);

            var labelCol = createElem('div', ['col-sm-4']);
            var labelLabel = createElem('label');
            labelLabel.innerText = 'Label';
            var labelInput = createElem('input', ['form-control']);
            labelInput.type = 'text';
            labelInput.name = 'custom_form_field[options][' + optionsCount + '][label]';
            $(labelInput).attr('data-id', optionsCount);
            $(labelInput).on('input', function () {
                $(option).attr('label', $(labelInput).val());
            });

            var optionsSelectedHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#options').data('options-selected-help')});
            var optionsLabelHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#options').data('options-label-help')});
            var optionsValueHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#options').data('options-value-help')});

            var checkedLabel = createElem('label');
            checkedLabel.innerText = 'Selected';
            var checkbox = createElem('input', ['published']);
            checkbox.type = 'radio';
            checkbox.checked = option.selected;
            checkbox.name = "groupSwitches";
            $(checkbox).attr('data-id', optionsCount);

            var hiddenCheckbox = createElem('input', ['hidden_fields']);
            hiddenCheckbox.type = 'hidden';
            hiddenCheckbox.name = 'custom_form_field[options][' + optionsCount + '][selected]';
            hiddenCheckbox.value = 'false';
            $(hiddenCheckbox).attr('data-id', optionsCount);
            bootstrapSwitchChange(checkbox, 'selected', true);

            var valueCol = createElem('div', ['col-sm-5']);
            var valueLabel = createElem('label');
            valueLabel.innerText = 'Value';
            var valueInput = createElem('input', ['form-control']);
            valueInput.type = 'text';
            valueInput.name = 'custom_form_field[options][' + optionsCount + '][value]';
            $(valueInput).attr('data-id', optionsCount);
            $(valueInput).on('input', function () {
                $(option).attr('value', $(valueInput).val());
            });

            $(checkedCol).append(checkedLabel);
            $(checkedCol).append(' ');
            $(checkedCol).append(optionsSelectedHelpIcon);
            $(checkedCol).append(hiddenCheckbox);
            $(checkedCol).append(checkbox);
            $(checkbox).bootstrapSwitch({onColor: 'success', offColor: 'warning'});
            $(checkbox).css('vertical-align', 'bottom');
            $(row).append(checkedCol);

            $(labelCol).append(labelLabel);
            $(labelCol).append(' ');
            $(labelCol).append(optionsLabelHelpIcon);
            $(labelCol).append(labelInput);
            $(row).append(labelCol);

            $(valueCol).append(valueLabel);
            $(valueCol).append(' ');
            $(valueCol).append(optionsValueHelpIcon);
            $(valueCol).append(valueInput);
            $(row).append(valueCol);

            $(wrapper).append(row);
            $('#options_container').append(wrapper);

            $(select).append(option);
            optionsCount++;
        };

        $('.custom-form-field-form').submit(function () {
            $('.published').remove();
        });
    }
});
